import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { OptTaskDetails } from '../../../models/admin/OptTaskDetails';

/**
 * An adapter converts optimisation task details HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class OptTaskDetailsAdapter implements Adapter<OptTaskDetails> {

  /**
   * Converts optimisation task details HTTP response to {@link OptTaskDetails}.
   * @param item optimisation task details HTTP response.
   */
  adapt(item): OptTaskDetails {
    return new OptTaskDetails(
      item.storeId,
      item.storeName,
      item.status,
      item.lastComplete);
  }
}
